import { gql } from '@apollo/client';
import client from 'graphql/client';
import { CompanyTechTagsMutationPayload } from './types';

export const fetchCompanyTechTags = () => {
  const query = gql`
    query companyProfileTechTagsOld {
      companyProfileTechTags {
        tags {
          id
          name
        }
        total
      }
    }
  `;

  return client.query({
    query,
  });
};

export const mutateCompanyTechTags = async (variables: CompanyTechTagsMutationPayload) => {
  const { profileId, tags: submittedTags } = variables;

  const tags = submittedTags.map((tag: string) => ({
    name: tag,
  }));

  const mutation = gql`
    mutation companyProfileTech($profileId: Int!, $tags: [CompanyTechTagInput!]!) {
      companyProfileUpdateTechStack(id: $profileId, tags: $tags) {
        id
        name
      }
    }
  `;

  return client.mutate({
    mutation,
    variables: {
      profileId,
      tags,
    },
  });
};
